/**
 * Módulo de definiciones de providers para analítica
 * GTM / GA / etc
 * ----
 * @event `route_change` ocurren al cambiar de ruta en la navegación
 * from: Se está abandonando la ruta en cuestión
 * to: Se está yendo a la ruta en cuestión
 */

import { GTM } from "./providers/gtm";

const analyticsDb = {
  triggers: {
    route_change: {
      from: {},
      to: {
        paso1: ["GTM.to_paso1"],
        paso2: ["GTM.to_paso2"],
        paso3: ["GTM.to_paso3"],
        paso4: ["GTM.to_paso4"],
        oferta: ["GTM.to_oferta"],
        ofertaCuenta: ["GTM.to_oferta"],
        mensaje: ["GTM.to_mensaje"],
        gracias: ["GTM.app_completed"],
        thank: ["GTM.app_completed"],
        cliente: ["GTM.app_completed"],
        noCliente: ["GTM.app_completed"],
        clienteCA: ["GTM.app_completed"]
      }
    },
    interaction_link: ["GTM.interaction_link"]
  },
  providers: {
    GTM
  }
};

export default analyticsDb;
